module.exports = __webpack_public_path__ + "media/images/blurbimg-a65ce67ea76f7336de8ce491ae0bf369.png";